import React from "react";
import { Box, Paper, Text, Title, Group, Badge } from "@mantine/core";

const EpreuveWordByWordTranscription = ({ epreuve }) => {
    if (!epreuve) {
        return <Text>Données non disponibles</Text>;
    }

    // Parse the JSON string from consigne to get temps_lecture if it exists
    const getTempsEstime = () => {
        if (!epreuve?.consigne || !epreuve.consigne[0]) return null;

        try {
            const consigneObj = JSON.parse(epreuve.consigne[0]);
            return consigneObj.temps_lecture;
        } catch (error) {
            // If it's not JSON, it might be the old format
            return null;
        }
    };

    const tempsEstime = getTempsEstime();

    return (
        <Box>
            <Paper p={20} withBorder radius="md">
                <Title order={3} mb={20}>
                    {epreuve.titre || "Transcription mot par mot"}
                </Title>

                <Group mb={15}>
                    <Badge color="blue" size="lg">
                        Type: Transcription mot par mot
                    </Badge>
                    {epreuve.bareme && (
                        <Badge color="green" size="lg">
                            Barème: {epreuve.bareme}
                        </Badge>
                    )}
                    {tempsEstime && (
                        <Badge color="orange" size="lg">
                            Temps estimé: {tempsEstime} secondes
                        </Badge>
                    )}
                </Group>

                {epreuve.correction_dp && Array.isArray(epreuve.correction_dp) && epreuve.correction_dp.length > 0 && (
                    <Box mt={20}>
                        <Title order={4} mb={15}>
                            Mots à transcrire:
                        </Title>
                        <Group spacing="xs" wrap>
                            {epreuve.correction_dp.map((word, index) => (
                                <Paper
                                    key={index}
                                    p={10}
                                    withBorder
                                    radius="sm"
                                    style={{ minWidth: '120px', textAlign: 'center' }}
                                >
                                    <Text size="sm" weight={500}>
                                        {index + 1}. {word}
                                    </Text>
                                </Paper>
                            ))}
                        </Group>
                    </Box>
                )}

                {(!epreuve.correction_dp || epreuve.correction_dp.length === 0) && (
                    <Box mt={20}>
                        <Text color="dimmed">Aucun mot défini</Text>
                    </Box>
                )}
            </Paper>
        </Box>
    );
};

export default EpreuveWordByWordTranscription; 